import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Fade } from "react-awesome-reveal";

import SectionTitle from "../home/SectionTitle";

const MISSION_ITEMS = ["whyUs.mission.item1", "whyUs.mission.item2", "whyUs.mission.item3", "whyUs.mission.item4", "whyUs.mission.item5"];
const VISION_ITEMS = ["whyUs.vision.item1", "whyUs.vision.item2", "whyUs.vision.item3", "whyUs.vision.item4", "whyUs.vision.item5"];

function Card({ chipKey, headingKey, items, t }) {
  return (
    <Fade triggerOnce direction="up" duration={700} className="flex-1">
      <div className="bg-[#f8faff] border border-[#eaeaea] rounded-[24px] p-[25px] lg:p-[40px] flex flex-col gap-[20px] h-full">
        <div className="bg-white inline-flex items-center self-start px-[12px] py-[8px] rounded-full">
          <span className="font-['Inter'] font-bold text-[12px] tracking-[1.44px] uppercase text-[#1c385f]">
            {t(chipKey)}
          </span>
        </div>
        <p className="font-28-18">{t(headingKey)}</p>
        <div className="flex flex-col gap-[14px]">
          {items.map((key) => (
            <div key={key} className="flex items-start gap-[12px]">
              <span className="font-['Inter'] font-bold text-[16px] text-[#4da6ff] leading-[1.3]">✓</span>
              <p className="font-16-14 flex-1">{t(key)}</p>
            </div>
          ))}
        </div>
      </div>
    </Fade>
  );
}

function MissionVision() {
  const { t } = useTranslation();
  const [active, setActive] = useState("mission");

  const tabs = [
    { id: "mission", labelKey: "whyUs.mission.chip" },
    { id: "vision", labelKey: "whyUs.vision.chip" },
  ];

  return (
    <section className="mt">
      <div className="glcontainer">
        <div className="hidden sm:block">
          <SectionTitle
            title1={t("whyUs.mission.title1")}
            title2={t("whyUs.mission.title2")}
            text={t("whyUs.mission.subtitle")}
            className="mx-auto mb-[40px]"
          />
        </div>
        <div className="sm:hidden">
          <SectionTitle
            title1={t("whyUs.mission.title1")}
            title2={t("whyUs.mission.title2")}
            text={t("whyUs.mission.subtitle")}
            align="left"
            className="mb-[25px]"
          />
        </div>

        {/* Мобильный переключатель Mission / Vision */}
        <div className="sm:hidden flex gap-[16px] mb-[25px]">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActive(tab.id)}
              className={`flex items-center px-[14px] py-[6px] rounded-full border border-[#1c385f] font-['Inter'] font-normal text-[14px] uppercase text-[#1c385f] transition-colors ${
                active === tab.id ? "bg-[#bfccd7]" : ""
              }`}
            >
              {t(tab.labelKey)}
            </button>
          ))}
        </div>

        {/* Desktop: обе карточки, mobile: активная */}
        <div className="flex gap-[24px]">
          <div className={`flex-1 ${active === "mission" ? "flex" : "hidden"} sm:flex`}>
            <Card chipKey="whyUs.mission.chip" headingKey="whyUs.mission.heading" items={MISSION_ITEMS} t={t} />
          </div>
          <div className={`flex-1 ${active === "vision" ? "flex" : "hidden"} sm:flex`}>
            <Card chipKey="whyUs.vision.chip" headingKey="whyUs.vision.heading" items={VISION_ITEMS} t={t} />
          </div>
        </div>
      </div>
    </section>
  );
}

export default MissionVision;
